import { useAccessLogs, useAccessLogsFilters } from 'app/api/useAccessLogs';
import { useState } from 'react';
import { DateTimePicker, Localization } from 'react-widgets';
import MomentLocalizer from 'react-widgets-moment';
import { i18n } from 'app/utils/i18n';

import moment from 'moment';
import { useParams } from 'react-router';
moment.locale('sv');

export const AccessLogs = () => {
  const [filter, setFilterValues] = useState({
    document: [],
    section: [],
    user: [],
    startDate: null,
    endDate: null,
  });
  const { documentId } = useParams();

  const { data: accessLogs } = useAccessLogs(filter, documentId);
  const { data: accessLogsFilters, isLoading: isAccessLogsFiltersLoading } = useAccessLogsFilters(documentId);

  const sectionNames = Array.from(new Set(accessLogs?.map((item) => item.sectionName)));
  const userNames = Array.from(new Set(accessLogs?.map((log) => log.userName)));
  const localizer = new MomentLocalizer(moment);

  const handleOnChecked = (e) => {
    const { key, value } = e;
    setFilterValues((prev) => {
      const previousScopeValues = prev[key] || [];
      const isChecked = previousScopeValues.includes(value);
      return {
        ...prev,
        [key]: isChecked ? previousScopeValues.filter((v) => v !== value) : [...previousScopeValues, value],
      };
    });
  };
  return (
    <>
      <div className="filter-wrapper">
        {!isAccessLogsFiltersLoading && (
          <>
            <CheckBoxFilter
              values={accessLogsFilters.sections}
              onCheckedCallBack={handleOnChecked}
              filterKey="section"
              label={i18n('access-logs.filter.section')}
            />
            <CheckBoxFilter values={accessLogsFilters.users} onCheckedCallBack={handleOnChecked} filterKey="user" label={i18n('access-logs.filter.user')} />
          </>
        )}
        <div>
          <h2>{i18n('access-logs.filter.start-date')}</h2>
          <Localization date={localizer}>
            <DateTimePicker
              includeTime={true}
              selectIcon={<i className="fa-regular fa-calendar"></i>}
              onChange={(e) => {
                if (filter.startDate) {
                  setFilterValues((prev) => ({
                    ...prev,
                    startDate: e ? moment(e, 'YYYY-MM-DD HH:mm').toISOString() : null,
                  }));
                } else {
                  setFilterValues((prev) => ({
                    ...prev,
                    startDate: e ? moment(e, 'YYYY-MM-DD').startOf('day').toISOString() : null,
                  }));
                }
              }}
              format="mmm YYY"
              value={filter.startDate ? new Date(filter.startDate) : null}
            />
          </Localization>
        </div>
        <div>
          <h2>{i18n('access-logs.filter.end-date')}</h2>
          <Localization date={localizer}>
            <DateTimePicker
              defaultValue={null}
              includeTime
              selectIcon={<i className="fa-regular fa-calendar"></i>}
              onChange={(e) => {
                if (filter.startDate) {
                  setFilterValues((prev) => ({
                    ...prev,
                    endDate: e ? moment(e, 'YYYY-MM-DD HH:mm').toISOString() : null,
                  }));
                } else {
                  setFilterValues((prev) => ({
                    ...prev,
                    endDate: e ? moment(e, 'YYYY-MM-DD').startOf('day').toISOString() : null,
                  }));
                }
              }}
              format="mmm YYY"
            />
          </Localization>
        </div>
      </div>
      <div className="accesslog-table-wrapper">
        <table className="accesslog-table">
          <thead>
            <tr>
              <th key={'empty'}></th>
              {sectionNames?.map((item) => {
                return (
                  <th className="accesslog-table-header" key={item}>
                    {item}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {userNames.map((user) => (
              <tr key={user}>
                <td className="accesslog-table-header name-row">
                  <span>{user}</span>
                </td>
                {sectionNames.map((section) => {
                  const record = accessLogs.find((r) => r.sectionName === section && r.userName === user);
                  return (
                    <td className="accesslog-table-cell" key={section}>
                      <span>{record ? moment(record.accessedAt).format('YYYY-MM-DD HH:mm') : ''}</span>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

const CheckBoxFilter = ({ values, onCheckedCallBack, filterKey, label }) => {
  return (
    <div>
      <h2>{label}</h2>

      <div className="checkbox-filter-wrapper">
        {values?.map((value) => (
          <div key={value.id} className="checkbox-filter-item">
            <input type="checkbox" id={value.id} name={value.name} onChange={(e) => onCheckedCallBack({ key: filterKey, value: value.id })} />
            <label htmlFor={value.id}>{value.name}</label>
          </div>
        ))}
      </div>
    </div>
  );
};
